import TaxonomyPage from "./TaxonomyPage";
import PhotoManager from "./PhotoManager";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import {
  apiListCategories, apiCreateCategory, apiUpdateCategory, apiDeleteCategory, apiReorderCategories,
  apiCategoryProducts, apiSetCategoryOrder,
} from "../adminApi";

export default function Categories() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-extrabold tracking-tight text-chalk">Categorie</h1>
        <p className="mt-1 text-sm text-steel">Gestisci foto, nomi, ordine e visibilità delle categorie.</p>
      </div>

      <Tabs defaultValue="foto">
        <TabsList data-testid="categories-tabs">
          <TabsTrigger value="foto" data-testid="categories-tab-foto">Foto categorie</TabsTrigger>
          <TabsTrigger value="elenco" data-testid="categories-tab-elenco">Elenco e ordine</TabsTrigger>
        </TabsList>

        <TabsContent value="foto" className="mt-5">
          <PhotoManager
            list={apiListCategories}
            update={apiUpdateCategory}
            imageField="image"
            labelField="label"
            uploadFolder="rinova/categories"
            uploadContext="card"
            testPrefix="catphoto"
            intro="Carica la foto di ogni categoria e regola la proporzione. L'anteprima mostra esattamente come apparirà sul sito. Consiglio: usa immagini con sfondo lime a pieno riquadro."
          />
        </TabsContent>

        <TabsContent value="elenco" className="mt-5">
          <TaxonomyPage
            title="Categorie"
            subtitle="Organizza i prodotti in categorie."
            nameLabel="Nome categoria"
            nameField="label"
            testidPrefix="category"
            hideHeader
            api={{
              list: apiListCategories,
              create: apiCreateCategory,
              update: apiUpdateCategory,
              remove: apiDeleteCategory,
              reorder: apiReorderCategories,
              products: apiCategoryProducts,
              setOrder: apiSetCategoryOrder,
            }}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
